import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ProductService } from '../services/product.service';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { NotificationService } from '../services/notification.service';
import { RestApiService } from '../services/restapi.service';
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from '../services/order.service';
import { ConfigService } from '../services/config.service';
import * as moment from 'moment';
import { SideNavBarService } from '../services/sidenavbar.service';
import { Cart1Service } from '../services/cart1.service';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { UtilityService } from '../services/utility.service';
import { PersistentService } from '../services/persistent.service';
import { AccountService } from '../services/account.service';
import { AutoshipConfigurationService } from '../services/autoshipConfiguration.service';
import { CompanyService } from '../services/company.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginDialogComponentComponent } from '../login-dialog-component/login-dialog-component.component';
import { FreeEnrollmentItemID } from 'src/app/constant';

@Component({
    selector: 'app-sidebar-summary-cart',
    templateUrl: './sidebar-summary-cart.component.html',
    styleUrls: ['./sidebar-summary-cart.component.scss']
})
export class SideBarSummaryCartComponent implements OnInit, OnDestroy {
    public commonData: any;
    public AutoshipMinDate: Date;
    public AutoshipMaxDate: Date;
    shouldRun: boolean = true;
    limit: 3;
    isShow: boolean;
    lastQuantity: 0;
    selectedfrequencyTypeID: 0;
    autoshipConfiguration: any = {
        setting: {
            allowEdit: true
        }
    };
    userService: UserServiceModal;
    currentState: any;
    checkoutVal: any;
    isPanelOpen: boolean = false;
    FreeEnrollmentItemID: any = FreeEnrollmentItemID;
    autoshipDate: any;
    autoshipId: any;
    private lastKnownServiceDate: any = null;
    private lastKnownLocalStorageDate: any = null;
    private checkInterval: any;
    private isMonitoring: boolean = false;
    private debounceTimeout: any;
    private updateInProgress: boolean = false;

    constructor(
        public configService: ConfigService,
        public orderService: OrderService,
        public user: UserService,
        public notificationService: NotificationService,
        public apiService: RestApiService,
        public translate: TranslateService,
        public sideNavBarService: SideNavBarService,
        public cart1Service: Cart1Service,
        public itemsService: ProductService,
        public location: Location,
        public router: Router,
        public utilityService: UtilityService,
        public persistentService: PersistentService,
        public accountService: AccountService,
        public autoshipConfigurationService: AutoshipConfigurationService,
        public companyService: CompanyService,
        public dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute
    ) {
        this.userService = user.userServiceModal;
        this.commonData = this.configService.getConfig();
        this.selectedfrequencyTypeID = this.persistentService.retailData.Autoship.FrequencyTypeID = this.commonData.FrequencyTypes[0].ID;
        this.AutoshipMinDate = moment().add(this.configService.localSettings.Autoship.AutoshipMinDate, 'days').toDate();
        this.AutoshipMaxDate = moment().add(this.configService.localSettings.Autoship.AutoshipMaxDate, 'days').toDate();
        this.route.queryParams.subscribe(params => {
            const id = params['autoshipId'];
            this.autoshipId = id;
        });
    }
    @Input() events: Observable<void>;

    ngOnInit() {
        this.currentState = this.location.path();
        this.initializeAutoshipDate();
        this.subscribeToAutoshipDateChanges();
        this.startAutoshipDateMonitoring();
        // Check if this is customer's first order for free shipping eligibility
        this.orderService.checkIfFirstOrder();
    }


    ngOnDestroy() {
        // Clean up interval when component is destroyed
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
        }
        
        // Clean up debounce timeout
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        
        // Clean up event listeners
        window.removeEventListener('storage', this.checkForAllDateChanges);
        window.removeEventListener('focus', this.checkForAllDateChanges);
        
        this.isMonitoring = false;
        this.updateInProgress = false;
    }

    private initializeAutoshipDate(): void {
        if (this.autoshipConfigurationService.autoshipDate) {
            this.autoshipDate = new Date(this.autoshipConfigurationService.autoshipDate);
        } else {
            const savedDate = sessionStorage.getItem('autoshipDate');
            if (savedDate) {
                this.autoshipDate = new Date(savedDate);
                this.autoshipConfigurationService.autoshipDate = this.autoshipDate;
            } else {
                this.autoshipDate = this.AutoshipMinDate;
                this.autoshipConfigurationService.autoshipDate = this.autoshipDate;
            }
        }
    }

    private subscribeToAutoshipDateChanges(): void {
        // Check if the service has observable functionality
        // For now, we'll rely on manual updates through onAutoshipDateChange
        // This method can be extended when the service supports observables
    }

    private startAutoshipDateMonitoring(): void {
        if (this.isMonitoring) {
            return; // Prevent multiple intervals
        }
        
        // Store the initial values
        this.lastKnownServiceDate = this.autoshipConfigurationService.autoshipDate;
        this.lastKnownLocalStorageDate = sessionStorage.getItem('autoshipDate');
        this.isMonitoring = true;
        
        // Reduced frequency - check every 5 seconds instead of 2
        this.checkInterval = setInterval(() => {
            // Only check if no update is currently in progress
            if (!this.updateInProgress) {
                this.checkForAllDateChanges();
            }
        }, 5000); // Optimized: Check every 5 seconds
        
        // Add event listeners for immediate updates
        this.addEventListeners();
    }

    private addEventListeners(): void {
        // Listen for storage changes with debouncing
        window.addEventListener('storage', (e) => {
            if (e.key === 'autoshipDate') {
                this.debouncedDateUpdate();
            }
        });

        // Listen for window focus - only check if tab was inactive
        let isTabActive = true;
        window.addEventListener('blur', () => {
            isTabActive = false;
        });
        
        window.addEventListener('focus', () => {
            if (!isTabActive) {
                this.debouncedDateUpdate();
                isTabActive = true;
            }
        });
    }

    private debouncedDateUpdate(): void {
        // Clear existing timeout to prevent multiple rapid updates
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        
        // Debounce updates to prevent rapid successive calls
        this.debounceTimeout = setTimeout(() => {
            this.checkForAllDateChanges();
        }, 300); // Wait 300ms before updating
    }

    private checkForAllDateChanges(): void {
        // Early return if update already in progress
        if (this.updateInProgress) {
            return;
        }
        
        let hasChanged = false;
        
        // Quick check - only proceed if values actually differ
        const currentServiceDate = this.autoshipConfigurationService.autoshipDate;
        const currentLocalStorageDate = sessionStorage.getItem('autoshipDate');
        
        // Optimized comparison - avoid unnecessary processing
        if (currentServiceDate !== this.lastKnownServiceDate) {
            this.lastKnownServiceDate = currentServiceDate;
            hasChanged = true;
        }
        
        if (currentLocalStorageDate !== this.lastKnownLocalStorageDate) {
            this.lastKnownLocalStorageDate = currentLocalStorageDate;
            hasChanged = true;
        }
        
        // Only update if something actually changed
        if (hasChanged) {
            this.updateComponentDate();
        }
    }

    private updateComponentDate(): void {
        // Prevent concurrent updates
        if (this.updateInProgress) {
            return;
        }
        
        this.updateInProgress = true;
        
        try {
            let newDate: Date | null = null;
            const serviceDate = this.autoshipConfigurationService.autoshipDate;
            const localStorageDate = sessionStorage.getItem('autoshipDate');
            
            // Smart priority logic - use the most recent/valid date
            if (localStorageDate) {
                const localDate = new Date(localStorageDate);
                
                if (!isNaN(localDate.getTime())) {
                    newDate = localDate;
                    
                    // Only sync if actually different (avoid unnecessary writes)
                    if (!serviceDate || new Date(serviceDate).getTime() !== localDate.getTime()) {
                        this.autoshipConfigurationService.autoshipDate = localDate;
                    }
                }
            }
            
            // Fallback to service if localStorage is invalid/empty
            if (!newDate && serviceDate) {
                const svcDate = new Date(serviceDate);
                
                if (!isNaN(svcDate.getTime())) {
                    newDate = svcDate;
                    
                    // Only sync if different
                    const currentStored = sessionStorage.getItem('autoshipDate');
                    if (!currentStored || new Date(currentStored).getTime() !== svcDate.getTime()) {
                        sessionStorage.setItem('autoshipDate', svcDate.toISOString());
                    }
                }
            }
            
            // Final fallback to minimum date
            if (!newDate) {
                newDate = this.AutoshipMinDate;
                
                // Sync both sources with default
                this.autoshipConfigurationService.autoshipDate = newDate;
                sessionStorage.setItem('autoshipDate', newDate.toISOString());
            }
            
            // Only update component if actually different
            if (newDate && (!this.autoshipDate || newDate.getTime() !== this.autoshipDate.getTime())) {
                this.autoshipDate = newDate;
                
                // Optimized: Use markForCheck instead of detectChanges for better performance
                this.cdr.markForCheck();
            }
        } finally {
            // Always reset the flag
            this.updateInProgress = false;
        }
    }

    myFilter = (d: Date): boolean => {
        const date = d?.getDate();
        return (
            date !== 26 &&
            date !== 27 &&
            date !== 28 &&
            date !== 29 &&
            date !== 30 &&
            date !== 31
        );
    };

    showTaxMessage() {
        return !(this.location.path().toLowerCase() == '/join') && !(this.location.path().toLowerCase() == '/checkout') &&
            (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedAutoOrderItems.length > 0 ||
                this.itemsService.selectedPacks.length > 0);
    }

    getPacksQuanity() {
        var quantity = 0;
        _.each(this.itemsService.selectedPacks, function (item) {
            quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
        });
        return quantity;
    }

    getOrderQuanity() {
        let quantity = 0;
        _.each(this.itemsService.selectedOrderItems, (item) => {
            if (!item.UsePoints) {
                quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
            }
            if (item.UsePoints) {
                quantity += (item.rewardQuantity ? parseInt(item.rewardQuantity, 10) : 0);
            }
        });
        return quantity;
    }

    getAutoOrderQuanity() {
        let quantity = 0;
        _.each(this.itemsService.selectedAutoOrderItems, (item) => {
            quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
        });
        return quantity;
    }

    removePromo(code) {
        this.userService.couponInfo.RewardsForUse = _.reject(this.userService.couponInfo.RewardsForUse, (e) => {
            return e.Code === code;
        });
        this.userService.couponInfo.promoCode = '';
        this.userService.couponInfo.promoCodeValid = false;
        this.userService.couponInfo.IsAppliedcode = false;
        this.userService.couponInfo.Allcoupons.splice(this.userService.couponInfo.Allcoupons.indexOf(code), 1);
        this.orderService.calculateOrder();
    }
    getCustomerTypeName(): any {
        const custmerType = _.find(this.configService.commonSettings.CustomerTypes, (item) => {
            return (item.ID == this.userService.customerTypeID);
        });
        if (custmerType) {
            return { type: custmerType.Description };
        }
    }

    dateFilter(date) {
        let disableDates = [];
        if (disableDates.length === 0) {
            disableDates = [];
        }
        return disableDates.indexOf(moment(date).format('DD MMMM YYYY')) === -1;
    }

    submitApplication() {
        document.querySelectorAll<HTMLElement>('#place-order-btn')[0].click();
    }

    checkitem() {
        if (this.utilityService.getAutoshipEditFlag()) {
            return true;
        }
        return (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedAutoOrderItems.length > 0);
    }

    navigateToNextStep() {
        this.sideNavBarService.triggerOpen();
        if (this.currentState.toLowerCase() == '/checkout' && (Object.keys(this.userService.customerData).length)
            && (this.userService.customerData.CustomerId || this.userService.customerData.PrimaryAddress.Region) && this.checkitem()
            && this.user.checkIfUserAuthenticatedOrNot()) {
            this.submitApplication();
        } else if (this.currentState.toLowerCase() != '/checkout' && (Object.keys(this.userService.customerData).length)
            && (this.userService.customerData.CustomerId || this.userService.customerData.PrimaryAddress.Region)
            && this.checkitem() && this.user.checkIfUserAuthenticatedOrNot()) {
            this.autoshipId ? this.router.navigate(['/checkout'], { queryParams: { autoshipId: this.autoshipId }}) : this.router.navigate(['/checkout']);
        } else if (this.checkitem() && ((Object.keys(this.userService.customerData).length === 0 && !this.userService.customerData.CustomerId)
            || !this.user.checkIfUserAuthenticatedOrNot())) {
            if (this.currentState.toLowerCase() == '/checkout') {
                this.accountService.logout();
            }
            this.loginDialog();
        } else if (this.currentState.toLowerCase() != '/products/all') {
            this.router.navigate(['/products/all']);
        } else if (!this.checkitem()) {
            this.notificationService.error('error_', 'error_no_item_selected');
        }
    }


    navigateToApplication() {
        const application = (this.configService.localSettings.Global.ConfigurableCheckout && this.userService.customerData.CustomerId) ? '/checkout' : '/join';
        this.sideNavBarService.triggerOpen();
        if ((Object.keys(this.userService.customerData).length || this.userService.guestUserData.Email) &&
            (this.userService.customerData.CustomerId || this.userService.customerData.PrimaryAddress.Region || this.userService.guestUserData.Email)
            && this.checkitem() && this.user.checkIfUserAuthenticatedOrNot()) {
            // this.router.navigate([application]);
            this.autoshipId ? this.router.navigate([application], { queryParams: { autoshipId: this.autoshipId }}) : this.router.navigate([application]);
        } else if (this.checkitem() && ((Object.keys(this.userService.customerData).length === 0
            && !this.userService.customerData.CustomerId) || !this.user.checkIfUserAuthenticatedOrNot())) {
            if (this.location.path().toLowerCase() == '/checkout' || this.userService.guestUserLogin) {
                this.accountService.logout();
            }
            this.loginDialog();
        } else if (this.location.path().toLowerCase() != '/products/all') {
            this.router.navigate(['/products/all']);
        } else if (!this.checkitem()) {
            this.notificationService.error('error_', 'error_no_item_selected');
        }
    }

    showLogincheckoutBtn() {
        const path = this.location.path().toLowerCase();
        return path !== '/checkout' && path !== '/join';
    }

    useCoupons() {
        return (
            this.userService.couponInfo.OrderAllowCoupons &&
            this.userService.couponInfo.availableRewards &&
            this.userService.couponInfo.availableRewards.length
        );
    }

    checkRewardStatus(reward) {
        const isInUse = this.userService.couponInfo.RewardsForUse.some((currentReward) => {
            return currentReward.Code === reward.Code;
        });
        return isInUse;
    }

    toggleCoupon(coupon) {
        const applied = this.userService.couponInfo.RewardsForUse.some((reward) => {
            return reward.Code === coupon.Code;
        });

        if (applied && this.userService.DynamicCouponCode.promoCode != coupon.Code) {
            this.removePromo(coupon.Code);
        } else {
            this.userService.couponInfo.RewardsForUse.push(coupon);
            if (this.userService.couponInfo.RewardsForUse.length) {
                _.each(this.userService.couponInfo.RewardsForUse, (reward) => {
                    const IsCouponAvailable = this.userService.couponInfo.Allcoupons.some((coupon) => {
                        return reward.Code === coupon;
                    });
                    if (!IsCouponAvailable) {
                        this.userService.couponInfo.Allcoupons.push(reward.Code);
                    }

                });
            }
            this.orderService.calculateOrder();
        }
    }


    goToSignUp() {
        this.sideNavBarService.triggerOpen();
        if (this.itemsService.selectedOrderItems == 0 && this.configService.localSettings.Global.OrderItemRequired[this.userService.customerTypeID]) {
            const msg = 'unified_order_item_required';
            this.notificationService.error('error_', this.translate.instant(msg));
            return;
        }
        //<!-- ************** uncomment when real peoducts come or in prod mode ***************** -->
        // if (this.itemsService.selectedAutoOrderItems == 0 && this.configService.localSettings.Global.AutoshipItemRequired[this.userService.customerTypeID]) {
        //     const AutoshipMsg = 'unified_auto_order_item_required';
        //     this.notificationService.error('error_', this.translate.instant(AutoshipMsg));
        //     return;
        // }
        this.router.navigate(['/signup']);
    }
    loginDialog() {
        const dialogRef = this.dialog.open(LoginDialogComponentComponent, {
            width: "600px",
            autoFocus: false
        });

        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    showNewCustomerBtn() {
        if (this.user.checkIfUserAuthenticatedOrNot()) {
            return false;
        } else if (this.location.path().toLowerCase() == '/signup' || this.location.path().toLowerCase() == '/join') {
            return false;
        } else {
            return true;
        }

    }

    isLoggedIn() {
        if ((Object.keys(this.userService.customerData).length) && (this.userService.customerData.CustomerId) && this.user.checkIfUserAuthenticatedOrNot()) {
            return true;
        } else {
            return false;
        }
    }

    isAutoshipChanged() {
        if (!moment(this.autoshipConfigurationService.autoshipDate).isSame(this.persistentService.retailData.autoshipDate, 'day')) {
            return true;
        }
        if (this.persistentService.retailData.Autoship && this.commonData.FrequencyTypes[0].ID != this.persistentService.retailData.Autoship.FrequencyTypeID) {
            return true;
        }
        if (this.userService.isAddressChanged || this.userService.isPaymentChanged || this.userService.isShipMethodChanged) {
            return true;
        }

        if (this.utilityService.getAutoshipEditFlag()) {
            if (this.persistentService.retailData.isChanged) {
                if (_.isEqual(this.persistentService.retailData.editAutoshipItems, this.itemsService.selectedAutoOrderItems) &&
                    this.itemsService.selectedOrderItems.length == 0) {
                    return false;
                }
                return true;
            }
            return false;
        }
        return true;
    }

    cancelAutoship() {
        this.router.navigate(['/manageautoship']);
        this.sideNavBarService.triggerOpen();
        this.notificationService.success('Success', this.translate.instant('autoship_cancel'));
    }

    deleteAutoship(autoShipId?: number) {

        this.apiService.deleteAutoship(autoShipId).subscribe((result) => {
            if (result && Number(result.Status) === 1) {
                this.notificationService.error('error_', this.translate.instant('some_error_occur_try_again'));
            } else {
                this.notificationService.success('Success', this.translate.instant('successfully_deleted'));
            }
        }, (error) => {
        }, () => {
        });
    }

    setFrequency() {
        this.commonData.FrequencyTypes.some((freq) => {
            if (freq.ID == this.persistentService.retailData.Autoship.FrequencyTypeID) {
                this.persistentService.retailData.Autoship.FrequencyTypeID = freq.ID;
                this.persistentService.retailData.Autoship.FrequencyTypeID = freq.ID;
                this.persistentService.retailData.Autoship.FrequencyTypeDescription = freq.Description;
                this.persistentService.retailData.isChanged = true;
                return;
            }
        });
    }

    saveEditAutoship() {
        this.sideNavBarService.triggerOpen();
        this.router.navigate(['/manageautoship']);
    }

    NavigateToAutoship() {
        this.sideNavBarService.triggerOpen();
        this.persistentService.retailData.AddMoreItemInAutoshipFlag = false;
        this.utilityService.setAutoshipEditFlag(false);
        this.persistentService.retailData.CurrentSelectedAutoOrder = 0;
        this.persistentService.retailData.AddMoreItemInAutoshipData = {};
        this.cart1Service.clearCart();
        this.router.navigate(['/manageautoship']);

    }
    NavigateToAutoshipShop() {
        if (this.autoshipId) {
            this.router.navigate(['/autoship'], { queryParams: { autoshipId: this.autoshipId } });
        }
        else {
            this.router.navigate(['/autoship']);
        }
    }
    NavigateToShop() {
        this.navigateToAppropriatePage();
    }
    locationCheck() {
        const currentUrl = this.router.url;
        return currentUrl.includes('/autoshiping') ? true : false;
    }

    /**
     * Helper method to check if we're in autoship flow
     * @returns boolean indicating if we're in autoship flow
     */
    private isAutoshipFlow(): boolean {
        return this.utilityService.getAutoshipEditFlag() || 
               this.location.path().toLowerCase().includes('/autoship') ||
               this.location.path().toLowerCase().includes('/autoshiping') ||
               this.location.path().toLowerCase().includes('/manage-autoship');
    }

    /**
     * Helper method to navigate to the appropriate page based on current flow
     */
    private navigateToAppropriatePage(): void {
        if (this.isAutoshipFlow()) {
            // Navigate to autoship page when in autoship flow
            if (this.autoshipId) {
                this.router.navigate(['/autoship'], { queryParams: { autoshipId: this.autoshipId } });
            } else {
                this.router.navigate(['/autoship']);
            }
        } else {
            // Navigate to shop for normal flow
            this.router.navigate(['/shop']);
        }
    }
    getAutoshipNumber() {
        return this.translate.instant('_invoice_autoorder') +
            this.persistentService.retailData.CurrentSelectedAutoOrder;
    }
    canCheckOut() {
        if (this.userService.customerData.CustomerId) {
            return true; // this.rewardPointsService.validatePointBalance();
        }
        return true;
    }

    getItems(type: string) {
        return this.itemsService[type == 'pack' ? 'selectedPacks' : (type == 'autoship' ? 'selectedAutoOrderItems' : 'selectedOrderItems')];
    }


    getImage(item) {
        return (item.OptionsImage && item.ImageUrl.substr(0, item.ImageUrl.lastIndexOf('/'))
            .concat(item.OptionsImage)) || item.ImageUrl;
    }

    view() {
        this.isShow = !this.isShow;
    }

    getQuantityModel(type, item): any {
        return this.cart1Service[type == 'pack' ? 'packQuantity' : (type == 'autoship' ? 'autoshipQuantity' : ((item && item.UsePoints) ? 'orderRewardQuantity' : 'orderQuantity'))];
    }

    increaseQuantiy(type, item) {
        this.cart1Service.increaseQuantiy(item, type == 'autoship', type == 'pack');
        this.updateQuantity(type, item, undefined);
    }

    decreaseQuantiy(type, item) {
        // For autoship flow, allow removal of all items including the last one
        if (type === 'autoship') {
            const currentQuantity = this.getQuantityModel(type, item)[item.ItemID] || 0;
            const totalAutoshipItems = this.itemsService.selectedAutoOrderItems.length;
            
            // If this is the last item with quantity 1, removing it will redirect to shop
            if (currentQuantity <= 1 && totalAutoshipItems <= 1) {
                // Allow the removal - it will trigger redirect to shop via cart1.service logic
                this.cart1Service.decreaseQuantiy(item, type == 'autoship', type == 'pack');
                this.updateQuantity(type, item, (item.Quantity === 0));
                return;
            }
        }
        // For order items in enrollment flow, check if we're trying to decrease below minimum
        else if (type === 'order') {
            const currentQuantity = this.getQuantityModel(type, item)[item.ItemID] || 0;
            if (currentQuantity <= 1) {
                this.notificationService.error('error_', this.translate.instant('unifiedapplication_cannot_remove_item_from_enrollment'));
                return;
            }
        }
        
        this.cart1Service.decreaseQuantiy(item, type == 'autoship', type == 'pack');
        this.updateQuantity(type, item, (item.Quantity === 0));
    }

    removeFromCart(type, item, forceRemove: boolean = false) {
        // For enrollment flow, prevent removal of items with quantity 1 unless forceRemove is true
        if ((type === 'order' || type === 'autoship') && !forceRemove) {
            const currentQuantity = this.getQuantityModel(type, item)[item.ItemID] || 0;
            if (currentQuantity <= 1) {
                this.notificationService.error('error_', this.translate.instant('unifiedapplication_cannot_remove_item_from_enrollment'));
                return;
            }
        }
        
        this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true);
        this.updateQuantity(type, item, true);
    }

    updateQuantity(type, item, remove) {
        // TODO:: this is bad remove this.
        if (!(type == 'autoship')) {
        }
    }

    closeCart() {
        let newUrl: any;
        if (this.itemsService.selectedAutoOrderItems.length === 0 && this.itemsService.selectedOrderItems.length === 0) {
            // const subdomain = getSubdomain(window.location.host);
            // if (subdomain) {
            //     newUrl = window.location.href.replace(subdomain, this.userService.WebAlias);
            // }
            // if (this.location.path().toLowerCase().indexOf('product') > -1) {
            //     this.router.navigate(['/products/all']);
            // }
            // else if (this.location.path().toLowerCase() === '/join') {
            //     this.router.navigate(['/join']);
            // }
            if ([1, 3].includes(parseInt(sessionStorage.getItem('selectedCustomerTypeID')))) {
                return;
            } else {
                this.navigateToAppropriatePage();
                this.sideNavBarService.triggerOpen();
            }
        }

    }

    checkQuantity(type, item) {
        const quantity = this.getQuantityModel(type, item)[item.ItemID];
        
        // For enrollment flow, ensure minimum quantity of 1 for order and autoship items
        let minQuantity = 0;
        if ((type === 'order' || type === 'autoship')) {
            minQuantity = 1; // Minimum quantity of 1 for enrollment flow
        }
        
        // Ensure quantity is not negative and respects minimum quantity
        const validQuantity = Math.max(minQuantity, Number(quantity) || 0);
        
        if (validQuantity === 0) {
            this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true);
        } else {
            // Update the quantity object first
            if (type == 'pack') {
                this.cart1Service.packQuantity[item.ItemID] = validQuantity;
            } else if (type == 'autoship') {
                this.cart1Service.autoshipQuantity[item.ItemID] = validQuantity;
            } else if (type == 'order') {
                if (!item.UsePoints) {
                    this.cart1Service.orderQuantity[item.ItemID] = validQuantity;
                } else {
                    this.cart1Service.orderRewardQuantity[item.ItemID] = validQuantity;
                }
            }
            
            // Update the item in the corresponding array
            if (!item.UsePoints) {
                item.Quantity = validQuantity;
            } else if (item.UsePoints) {
                item.rewardQuantity = validQuantity;
            }
            
            // Update localStorage and trigger calculate
            if (type == 'autoship') {
                sessionStorage.setItem('cart.autoship', JSON.stringify(this.itemsService.selectedAutoOrderItems));
                this.orderService.calculateAutoOrder();
            } else {
                sessionStorage.setItem((type == 'pack' ? 'cart.packs' : 'cart.order'),
                    JSON.stringify(type == 'pack' ? this.itemsService.selectedPacks : this.itemsService.selectedOrderItems));
                this.orderService.calculateOrder();
            }
        }
        this.updateQuantity(type, item, undefined);
    }

    getLastQuantity(type, item) {
        this.lastQuantity = this.getQuantityModel(type, item)[item.ItemID];
    }

    togglePanel() {
        this.isPanelOpen = !this.isPanelOpen;
        this.cdr.detectChanges();
    }
    onAutoshipDateChange(event: any): void {
        if (event?.value) {
            // Prevent concurrent updates during user interaction
            this.updateInProgress = true;
            
            const selectedDate = new Date(event.value);
            const dateToSave = selectedDate.toISOString();
            
            // Update all sources synchronously
            this.autoshipDate = selectedDate;
            this.autoshipConfigurationService.autoshipDate = selectedDate;
            sessionStorage.setItem('autoshipDate', dateToSave);
            
            // Update persistent service if needed
            if (this.persistentService.retailData) {
                this.persistentService.retailData.autoshipDate = dateToSave;
            }
            
            // Update tracking variables to prevent unnecessary syncs
            this.lastKnownServiceDate = selectedDate;
            this.lastKnownLocalStorageDate = dateToSave;
            
            // Use markForCheck for better performance
            this.cdr.markForCheck();
            
            // Reset update flag after a short delay
            setTimeout(() => {
                this.updateInProgress = false;
            }, 100);
            
            // Optionally trigger order recalculation if needed
            if (this.itemsService.selectedAutoOrderItems.length > 0) {
                this.orderService.calculateAutoOrder();
            }
        }
    }
    getAutoshipStartDate(): Date {
        if (this.autoshipDate) {
            return this.autoshipDate;
        } else if (this.autoshipConfigurationService.autoshipDate) {
            return new Date(this.autoshipConfigurationService.autoshipDate);
        } else {
            const savedDate = sessionStorage.getItem('autoshipDate');
            if (savedDate) {
                return new Date(savedDate);
            }
            return this.AutoshipMinDate;
        }
    }

    getFormattedAutoshipDate(): string {
        const date = this.getAutoshipStartDate();
        return moment(date).format('MMM DD, YYYY');
    }

    isAutoshipDateValid(): boolean {
        const date = this.getAutoshipStartDate();
        return date >= this.AutoshipMinDate && date <= this.AutoshipMaxDate;
    }

    // Method to refresh autoship date from service
    refreshAutoshipDate(): void {
        if (this.autoshipConfigurationService.autoshipDate) {
            const serviceDate = new Date(this.autoshipConfigurationService.autoshipDate);
            if (serviceDate.getTime() !== this.autoshipDate?.getTime()) {
                this.autoshipDate = serviceDate;
                this.cdr.detectChanges();
            }
        }
    }

    // Public method to manually trigger autoship date update check
    public forceAutoshipDateUpdate(): void {
        this.checkForAllDateChanges();
    }

    // Method to check if autoship date has been updated (legacy method - keeping for compatibility)
    checkForAutoshipDateUpdate(): void {
        this.checkForAllDateChanges();
    }

    // Method to check if there are monthly autoship items (excluding Annual Renewal Fee)
    hasMonthlyAutoshipItems(): boolean {
        if (!this.itemsService.selectedAutoOrderItems || this.itemsService.selectedAutoOrderItems.length === 0) {
            return false;
        }
        // Filter out the Annual Renewal Fee (ItemID: "9999") and check if there are other items
        const monthlyItems = this.itemsService.selectedAutoOrderItems.filter(item => item.ItemID !== '9999');
        return monthlyItems.length > 0;
    }

    // Method to check if the current country is eligible for free shipping
    isFreeShippingEligibleCountry(): boolean {
        const selectedCountry = this.configService.commonData.selectedCountry || 'US';
        const excludedCountries = ['CA', 'AU', 'NZ'];
        return !excludedCountries.includes(selectedCountry?.toUpperCase());
    }

    // Method to check if user qualifies for first order free shipping
    isFirstOrderFreeShipping(): boolean {
        // Check if this is a first order (from order service flag)
        return this.orderService.isFirstOrder && this.isFreeShippingEligibleCountry();
    }

    // Method to check if free shipping is currently being applied
    // This is a fallback check - if shipping total is $0, free shipping is active
    isFreeShippingApplied(): boolean {
        const shippingTotal = this.orderService.calculateOrderResponse?.ShippingTotal || 0;
        return shippingTotal === 0 && this.isFreeShippingEligibleCountry();
    }

    // Combined method to check if user qualifies for any free shipping condition
    qualifiesForFreeShipping(): boolean {
        return this.utilityService.isEnrollment() ||
               this.isFirstOrderFreeShipping() ||
               this.isFreeShippingApplied();
    }
}
